import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "k-drop-zones mb2" }
const _hoisted_4 = ["id", "data-index", "onPointerdown"]
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "k-pattern-mem-bottom" }
const _hoisted_7 = { class: "k-draggables-container" }
const _hoisted_8 = ["data-index"]
const _hoisted_9 = { class: "k-countdown-duration" }
const _hoisted_10 = {
  key: 0,
  class: "k-countdown-duration"
}

import * as GameTypes from 'types/game.types';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useModule } from 'src/modules/modules';
import { useMotion, useMotions } from '@vueuse/motion';
import { getGameSetTransitions, gameSetLeave } from '../transitions';
import GameContentArea from '../game-content-area.vue';
import DoneButton from '../done-button.vue';
import CountdownSeconds from 'src/components/countdown-seconds.vue';
import { getColorWithSimilarityInRange, getRandomNonUglyColor, deltaEInRange } from 'util/color-util';
import chroma from 'chroma-js';
import interact from 'interactjs';
import shuffle from 'lodash/shuffle';
import { computed } from '@vue/reactivity';
import { ascending } from 'src/util/audio-util';



export default /*#__PURE__*/_defineComponent({
  __name: 'pattern-memory',
  emits: ['next', 'fail'],
  setup(__props, { expose, emit }) {

_useCssVars(_ctx => ({
  "e84726a6": (_unref(theme).theme.cardBg)
}))

const { game, theme } = useModule();
const tones = ascending('FX_ascending_', 1, 8);

//const color = shallowRef(getRandomNonUglyColor());


const colors = ref<chroma.Color[]>([]);
const pattern = ref<{ [key:number]: chroma.Color }>({});
const placed = ref<{ [key:number]: number }>({});
const state = ref({
    distanceMin: 49,
    distanceMax: 100,
    patternCount: 4,
    countdownDuration: 5000,
    duration: 15000
})


const showDoneBtn = computed(() => {
    return Object.keys(placed.value).length === state.value.patternCount;
})

if (game.matchState.difficulty === 0){
    state.value = {
        distanceMin: 49,
        distanceMax: 100,
        patternCount: 3,
        countdownDuration: 5000,
        duration: 10000
    }
} else if (game.matchState.difficulty === 1) {
    state.value = {
        distanceMin: 40,
        distanceMax: 90,
        patternCount: 4,
        countdownDuration: 5000,
        duration: 10000
    }
} else if (game.matchState.difficulty === 2) {
    state.value = {
        distanceMin: 30,
        distanceMax: 80,
        patternCount: 4,
        countdownDuration: 6000,
        duration: 15000
    }
} else if (game.matchState.difficulty >= 4) {
    state.value = {
        distanceMin: 25,
        distanceMax: 60,
        patternCount: 6,
        countdownDuration: 7000,
        duration: 15000
    }
}

const getUniqueColor = () : chroma.Color => {
    let color = getRandomNonUglyColor();
    for (let i = 0; i < colors.value.length; i++) {
        let validRange = deltaEInRange(color, colors.value[i], 20, 100)
        if (!validRange) {
            return getUniqueColor();
        }
    }
    return color;
}

/**
 * Selects a number of random positions in the grid and generates a color for each. Populates the pattern
 * map and the color array, which is then shuffled and used to populate the draggable elements. Also applies
 * the proper background color to the appropriate zone fill elements.
 */
const generatePattern = () => {
    //Generate a number of unique indexes over our pattern/grid size (3x3=9)
    let gridPositions = new Set<number>();
    while (gridPositions.size < state.value.patternCount) {
        gridPositions.add(Math.floor(Math.random() * 9));
    }

    //Generate a color for each grid position and add it to the pattern map, assing color to zone fill el
    let gridColors : { [key:string]: chroma.Color } = {};
    for (let pos of gridPositions) {

        let gridColor = getUniqueColor();

        colors.value.push(gridColor);
        gridColors[pos] = gridColor;

        let fill = document.getElementById(`zone-fill${pos}`);
        if (fill) fill.style.background = gridColor.hex();
    }

    pattern.value = gridColors;
}

const resetDraggablePos = (draggableIndex: number) => {
    let draggable = <HTMLDivElement | null> document.querySelector(`.k-pattern-memory-draggable[data-index="${draggableIndex}"]`);
    if (draggable) {
        draggable.style.transform = 'translate(0px, 0px)';
        draggable.setAttribute('data-x', '0');
        draggable.setAttribute('data-y', '0');
    }
}

const clearZone = (zoneIndex: number) => {
    if (placed.value[zoneIndex] === undefined) return;

    //Reset zone color and return draggable back to its original position / make it visible
    let zone = <HTMLDivElement> document.getElementById(`zone${zoneIndex}`);
    let zoneFill = <HTMLDivElement> zone?.querySelector('.k-drop-zone-fill');
    let draggableIndex = placed.value[zoneIndex];
    let draggable = <HTMLDivElement> document.querySelector(`.k-pattern-memory-draggable[data-index="${draggableIndex}"]`);

    zoneFill.style.background = 'transparent';
    draggable.style.visibility = 'visible';
    delete placed.value[zoneIndex];

    tones.previous(true);
}

const placeZone = (zoneIndex: number, draggableIndex: number) => {
    if (placed.value[zoneIndex] !== undefined) {
        clearZone(zoneIndex);
    }   

    //Set zone color and move draggable to zone
    let zone = <HTMLDivElement> document.getElementById(`zone${zoneIndex}`);
    let zoneFill = <HTMLDivElement> zone?.querySelector('.k-drop-zone-fill');
    let draggable = <HTMLDivElement> document.querySelector(`.k-pattern-memory-draggable[data-index="${draggableIndex}"]`);
    //let color = colors.value[draggableIndex];

    zoneFill.style.background = colors.value[draggableIndex].hex();
    draggable.style.visibility = 'hidden';
    placed.value[zoneIndex] = draggableIndex;
    resetDraggablePos(draggableIndex);

    tones.next();
}

function dragMoveListener (event: Interact.DragEvent) {
    let d = <HTMLDivElement> event.target;
    let [x, y] = [parseFloat(d.getAttribute('data-x')  ?? '0'), parseFloat(d.getAttribute('data-y') ?? '0')];
    let [nextX, nextY] = [x + event.dx, y + event.dy];

    d.style.transform = `translate(${nextX}px, ${nextY}px)`;
    d.setAttribute('data-x', nextX.toString());
    d.setAttribute('data-y', nextY.toString());
}

const dragContainerRef = ref<HTMLDivElement>();
onMounted(() => {
    if (!dragContainerRef.value) return;
    interact('.k-pattern-memory-draggable').draggable({
        inertia: false,
        modifiers: [
            interact.modifiers.restrict({
                restriction: dragContainerRef.value.getBoundingClientRect(),
                endOnly: true
            })
        ],
        autoScroll: false,
        listeners: {
            move: dragMoveListener,
            end(event: Interact.DragEvent) {
                let draggable = event.target;
                    draggable.setAttribute('data-x', '0');
                    draggable.setAttribute('data-y', '0');
                    draggable.style.transition = `transform 300ms`;
                    draggable.style.transform = `translate(${0}px, ${0}px)`;
                    setTimeout(() => {
                        draggable.style.transition = `none`;
                    }, 300)
            }
        }
    })

    interact('.k-drop-zone').dropzone({
        accept: '.k-pattern-memory-draggable',
        overlap: 0.5,
        ondropactivate: (event) => {
            let dropzone = <HTMLDivElement> event.target;
                dropzone.classList.add('k-drop-active');
        },
        ondragenter: (event) => {
            let dropzone = <HTMLDivElement> event.target;
                dropzone.classList.add('k-drop-zone--hover');
        },
        ondragleave: function (event) {
            let dropzone = <HTMLDivElement> event.target;
                dropzone.classList.remove('k-drop-zone--hover');
        },
        ondrop: function (event) {
            let dropzone = <HTMLDivElement> event.target;
                dropzone.classList.remove('k-drop-zone--hover');

            let dropzoneIndex = parseInt(dropzone.getAttribute('data-index') ?? '0');
            let draggable = <HTMLDivElement> event.relatedTarget;
            let draggableIndex = parseInt(draggable.getAttribute('data-index') ?? '0');

            placeZone(dropzoneIndex, draggableIndex);
        },
        ondropdeactivate: function (event) {
            let dropzone = <HTMLDivElement> event.target;
                dropzone.classList.remove('k-drop-zone--hover');
        }
    })
});

const overlay = ref();
const { apply } = useMotion(overlay, {
    initial: {
        opacity: 0,
    },
    flash: {
        opacity: 1,
        transition: {
            duration: 0,
            ease: 'linear',
            onComplete: () => apply('flashExit')
        }
    },
    flashExit: {
        opacity: 0,
        transition: {
            duration: 3000,
            ease: 'easeOut'
        }
    }
})

const resetDropzoneFills = () => {
    document.querySelectorAll('.k-drop-zone-fill').forEach(node => {
        (<HTMLDivElement> node).style.background = 'transparent';
    })
}

const countdownComplete = ref(false);
const handleCountdownComplete = () => {
    apply('flash');
    resetDropzoneFills();
    colors.value = shuffle(colors.value);
    countdownComplete.value = true;
    game.clock.start(state.value.duration);
}


//Necessary if user skips before countdown is complete
onBeforeUnmount(() => {
    interact('.k-pattern-memory-draggable').unset();
    interact('.k-drop-zone').unset();
    //clearTimeout(countdownTimeout.value);
});

const countdownRef = ref();
const entered = ref(false);
const handleTransitionComplete = (index: number) => {
    if (entered.value === false && index === 8){
        entered.value = true;
        countdownRef.value?.start();
        //countdown();
    }
}

const container = ref();
const doneBtnRef = ref();
const leave = () => {
    return Promise.all([
        doneBtnRef.value?.leave(),
        container?.value.leave(),
        countdownRef.value?.leave(),
        gameSetLeave(useMotions())
    ]);
}

const handleSubmit = async () => {
    let patternEntries = Array.from(Object.entries(pattern.value));
    for (let i = 0; i < patternEntries.length; i++){
        let [zoneIndex, patternColor] = patternEntries[i];
        let draggableIndex = placed.value[parseInt(zoneIndex)];
        if (draggableIndex !== undefined){
            let placedColor = colors.value[draggableIndex];
            if (patternColor?.hex() !== placedColor?.hex()){
                emit('fail');
                return;
            }
        } else {
            emit('fail');
            return;
        }
    }

    emit('next', { background: colors.value[0] });
}

onMounted(generatePattern);
expose({
    leave
})

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createBlock(GameContentArea, {
    ref_key: "container",
    ref: container,
    onSkip: _cache[0] || (_cache[0] = () => emit('next', { skipped: true }))
  }, {
    instruction: _withCtx(() => [
      (!countdownComplete.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Memorize this pattern!"))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Drag each color into place to complete the pattern! Tap to reset any color you've already placed."))
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "overlay",
        ref: overlay,
        class: "k-flash-overlay"
      }, null, 512),
      _createElementVNode("div", {
        ref_key: "dragContainerRef",
        ref: dragContainerRef,
        class: "container-centered k-drag-container"
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (nRow, row) => {
            return _createElementVNode("div", {
              key: row,
              class: "k-drop-zone-row"
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (nCol, col) => {
                return _withDirectives(_createElementVNode("div", _mergeProps({
                  id: `zone${row * 3 + col}`,
                  "data-index": row * 3 + col,
                  class: "k-drop-zone",
                  onPointerdown: () => clearZone(row * 3 + col)
                }, _unref(getGameSetTransitions)(row * 3 + col, { onComplete: handleTransitionComplete })), [
                  _createElementVNode("div", {
                    id: `zone-fill${row * 3 + col}`,
                    class: "k-drop-zone-fill"
                  }, null, 8, _hoisted_5)
                ], 16, _hoisted_4), [
                  [_directive_motion, `btnMotion${row * 3 + col}`]
                ])
              }), 64))
            ])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colors.value, (c, i) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", _mergeProps({
                key: 9 + i,
                "data-index": i,
                class: "k-pattern-memory-draggable"
              }, _unref(getGameSetTransitions)(9 + i, { onComplete: handleTransitionComplete }), {
                style: { background: c.hex() }
              }), null, 16, _hoisted_8)), [
                [_directive_motion, `btnMotion${9 + i}`]
              ])
            }), 128))
          ], 512), [
            [_vShow, countdownComplete.value && !_unref(showDoneBtn)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            (!countdownComplete.value)
              ? (_openBlock(), _createBlock(CountdownSeconds, {
                  key: 0,
                  ref_key: "countdownRef",
                  ref: countdownRef,
                  class: "mt3",
                  count: state.value.countdownDuration / 1000,
                  autostart: false,
                  onEnd: handleCountdownComplete
                }, null, 8, ["count"]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !countdownComplete.value]
          ]),
          (_unref(showDoneBtn))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(DoneButton, {
                  ref_key: "doneBtnRef",
                  ref: doneBtnRef,
                  onClick: handleSubmit,
                  width: "25%"
                }, null, 512)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 512)
    ]),
    _: 1
  }, 512))
}
}

})